module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-login"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('div', {
    staticClass: "cubix-form"
  }, [_c('label', {
    attrs: {
      "for": "field-login"
    }
  }, [_vm._v("login: ")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.login),
      expression: "form.login"
    }],
    attrs: {
      "id": "field-login",
      "placeholder": "User id:",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "login", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "field-passwd"
    }
  }, [(_vm.form.login.length >= 4) ? _c('span', [_vm._v("hello " + _vm._s(_vm.form.login) + ", enter your ")]) : _vm._e(), _vm._v("password: ")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.passwd),
      expression: "form.passwd"
    }],
    attrs: {
      "id": "field-passwd",
      "placeholder": "Password:",
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.passwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "passwd", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.form.login.length >= 4 && _vm.form.passwd.length > 4) ? _c('div', {
    staticClass: "control"
  }, [_vm._v("\n            good .. now "), _c('a', {
    staticClass: "control button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("log in")])]) : _vm._e()]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  })], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656ff308"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/LoginForm.vue
// module id = 1837
// module chunks = 1